import styled from 'styled-components';
import media from '../../../../styles/media.style';

export const Wrapper = styled.div`
  margin: 20px;
  display: block;
  border: solid 1px #859db4;
`;

export const Layout = styled.div`
  display: block;
  width: 100%;
  margin: 20px auto;

  ${media.tabletP`
    display: table;
    width: 600px;
    margin: 40px auto;
  `};
`;

export const LayoutLeft = styled.div`
  display: block;
  width: 100%;

  ${media.tabletP`
    display: table-cell;
    width: 50%;
    text-align: left;
    vertical-align: top;
  `};
`;

export const LayoutRight = styled.div`
  display: block;
  width: 100%;
  margin: 40px 0 20px 0;

  ${media.tabletP`
    display: table-cell;
    width: 50%;
    text-align: center;
    vertical-align: middle;
  `};
`;

export const Title = styled.h1`
  position: relative;
  margin: 0;
  text-align: center;
  font-size: 18px;
  color: #000;
  overflow: hidden;
  padding: 0 40px;

  ${media.tabletP`
    padding: 0;
    margin-bottom: 20px;
    font-size: 20px;
    text-align: left;
  `};
`;

export const PowerContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  width: 100%;
  margin: 0 auto;
  margin-bottom: 10px;
  padding: 0 40px;

  &:last-child {
    margin-bottom: 0;
  }

  ${media.tabletP`
    padding: 0;
    margin-bottom: 5px;
  `};
`;

export const ImageContainer = styled.div`
  display: block;
  width: 250px;
  height: 187px;
  margin: 0 auto;
  position: relative;

  ${media.tabletP`
    width: 300px;
    height: 225px;
  `};

  .recommend {
    width: 75px;
    height: 75px;
    border-radius: 1000px;
    position: absolute;
    top: -25px;
    right: -10px;
    background-color: #cfd9e2;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: 10px;
    font-weight: bold;

    ${media.tabletP`
      top: -20px;
      right: -20px;
      font-size: 12px;
      width: 100px;
      height: 100px;
    `};
  }
`;

export const Icon = styled.div`
  position: relative;
  overflow: hidden;
  text-align: left;
  text-indent: -9999px;
  display: block;
  margin: 0 auto;
  width: 40px;
  height: 40px;
  border-radius: 20px;
  text-align: center;
  color: #fff;
  background-color: #bbb;
  &:before {
    position: absolute;
    top: 10px;
    left: 19px;
    width: 2px;
    height: 20px;
    display: block;
    content: '';
    background-color: #fff;
  }
  &:after {
    position: absolute;
    top: 19px;
    left: 10px;
    width: 20px;
    height: 2px;
    display: block;
    content: '';
    background-color: #fff;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SublimicDiagnosisResultPage/HairAndScalpCarePage/HairAndScalpCarePage.style.js